var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12H11.49C10.8456 11.0734 9.98652 10.3166 8.98609 9.79415C7.98565 9.27173 6.87362 8.99925 5.745 9C4.61638 8.99925 3.50434 9.27173 2.50391 9.79415C1.50348 10.3166 0.644374 11.0734 0 12ZM5.643 7C6.10263 7 6.55775 6.90947 6.98239 6.73358C7.40703 6.55769 7.79287 6.29988 8.11787 5.97487C8.44288 5.64987 8.70069 5.26403 8.87658 4.83939C9.05247 4.41475 9.143 3.95963 9.143 3.5C9.143 3.04037 9.05247 2.58525 8.87658 2.16061C8.70069 1.73597 8.44288 1.35013 8.11787 1.02513C7.79287 0.700121 7.40703 0.442313 6.98239 0.266421C6.55775 0.09053 6.10263 -6.84897e-09 5.643 0C4.71474 1.38321e-08 3.8245 0.368749 3.16813 1.02513C2.51175 1.6815 2.143 2.57174 2.143 3.5C2.143 4.42826 2.51175 5.3185 3.16813 5.97487C3.8245 6.63125 4.71474 7 5.643 7Z",
    fill: "#202020"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.4225ae06.svg";
export { ForwardRef as ReactComponent };